import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  x: "0px",
  y: "0px",
  viewBox: "0 0 31.9 31.7",
  width: "31.9",
  height: "57.537",
  "xml:space": "preserve"
}
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = ["stroke"]
const _hoisted_7 = ["stroke"]


export default /*#__PURE__*/_defineComponent({
  props: {
  color: {
    type: String,
    default: '#D4D4D4',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M10.5,19.3h2.1c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-2.1c-0.4,0-0.8,0.3-0.8,0.8S10.1,19.3,10.5,19.3z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_2),
      _createElementVNode("path", {
        d: "M10.5,14h2.1c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-2.1c-0.4,0-0.8,0.3-0.8,0.8S10.1,14,10.5,14z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_3),
      _createElementVNode("path", {
        d: "M18.8,19.3h2.1c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-2.1c-0.4,0-0.8,0.3-0.8,0.8S18.3,19.3,18.8,19.3z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_4),
      _createElementVNode("path", {
        d: "M18.8,24.6h2.1c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-2.1c-0.4,0-0.8,0.3-0.8,0.8S18.3,24.6,18.8,24.6z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_5),
      _createElementVNode("path", {
        d: "M18.8,14h2.1c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-2.1c-0.4,0-0.8,0.3-0.8,0.8S18.3,14,18.8,14z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_6),
      _createElementVNode("path", {
        d: "M31.2,9.9l-30-9.6C0.8,0.1,0.4,0.3,0.2,0.7C0.1,1.1,0.3,1.5,0.7,1.7l2.9,0.9v28.3c0,0.4,0.3,0.8,0.8,0.8h6.1c0,0,0,0,0,0   h4.1c0,0,0,0,0,0H27c0.4,0,0.8-0.3,0.8-0.8V10.3l3,1c0.1,0,0.2,0,0.2,0c0.3,0,0.6-0.2,0.7-0.5C31.8,10.4,31.6,10,31.2,9.9z    M13.9,30.2h-2.6v-5.6h2.6V30.2z M26.2,30.2H15.4v-6.3c0-0.4-0.3-0.8-0.8-0.8h-4.1c-0.4,0-0.8,0.3-0.8,0.8v6.3H5.1V3.1l21.1,6.8   V30.2z",
        fill: "none",
        stroke: __props.color,
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2"
      }, null, 8, _hoisted_7)
    ])
  ]))
}
}

})